import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import JuyangAiIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/juyang-ai'),
    name: 'juyang_ai_index',
    component: JuyangAiIndex,
    meta: {
      permissions: ['administrator', 'agent'],
      // 基础版和 V2 任一授权即可使用巨阳 AI，两个开关都关闭时禁止访问。
      accountFeatureFlags: [
        FEATURE_FLAGS.JUYANG_AI,
        FEATURE_FLAGS.JUYANG_AI_V2,
      ],
    },
  },
];
